import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';

import { UiTranslateModule } from '@fcom/ui-translate';
import { UiComponentsModule } from '@fcom/ui-components';
import { ComponentsModule } from '@fcom/common/components';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { DirectiveModule, FinFormsModule } from '@fcom/common';
import { ContentComponentsModule } from '@fcom/cms/components/content-components.module';
import { DestinationSearchModule } from '@fcom/destination-search/destination-search.module';
import { DESTINATION_SEARCH_FILTER_STATE_FEATURE_NAME } from '@fcom/destination-search/interfaces';
// DestinationSearchPageComponent is the page that incorporates other Components, they should be
// named with pattern DestinationSeachXXXComponent
import { OndMarketingDataService } from '@fcom/ond-marketing-landing-core/services';

import {
  DestinationSearchPageComponent,
  DestinationSearchFilterChipsComponent,
  DestinationSearchFilterToFieldComponent,
  DestinationSearchDateFieldComponent,
  DestinationSearchResultsComponent,
  DestinationSearchResultsItemComponent,
  DestinationSearchHeroComponent,
  DestinationSearchTravelClassSelectionComponent,
  SortOptionsComponent,
  DestinationSearchFormComponent,
  DestinationSearchOriginSelectorComponent,
  DestinationSearchFiltersComponent,
} from './components';
import { DestinationSearchOffersService } from './services/destination-search-offers.service';
import { destinationSearchFilterReducer } from './store';
import { DestinationSearchCampaignRibbonComponent } from './components/destination-search-campaign-ribbon/destination-search-campaign-ribbon.component';
import { DestinationSearchBarComponent } from './components/destination-search-bar/destination-search-bar.component';
import { DestinationSearchHeaderComponent } from './components/destination-search-header/destination-search-header.component';

@NgModule({
  imports: [
    StoreModule.forFeature(DESTINATION_SEARCH_FILTER_STATE_FEATURE_NAME, destinationSearchFilterReducer),
    CommonModule,
    UiTranslateModule,
    PipesModule,
    ComponentsModule,
    FormsModule,
    DirectiveModule,
    ContentComponentsModule,
    UiComponentsModule,
    GtmModule,
    FinFormsModule,
    DestinationSearchModule,
  ],
  declarations: [
    DestinationSearchPageComponent,
    DestinationSearchFilterChipsComponent,
    DestinationSearchFilterToFieldComponent,
    DestinationSearchFormComponent,
    DestinationSearchDateFieldComponent,
    DestinationSearchResultsComponent,
    DestinationSearchResultsItemComponent,
    DestinationSearchHeroComponent,
    DestinationSearchTravelClassSelectionComponent,
    SortOptionsComponent,
    DestinationSearchCampaignRibbonComponent,
    DestinationSearchBarComponent,
    DestinationSearchHeaderComponent,
    DestinationSearchOriginSelectorComponent,
    DestinationSearchFiltersComponent,
  ],
  exports: [DestinationSearchPageComponent, DestinationSearchHeroComponent],
  providers: [DestinationSearchOffersService, OndMarketingDataService],
})
export class DestinationSearchLazyModule {}
